export default __webpack_public_path__ + "static/media/p-3.460015b6.png";